import React from 'react';

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function EfficiencyInformationView() {
	return (
		<div className="efficiency-information">
			<h2 id="ga4-efficiency-information">Efficiency Information</h2>
			<div>
				<h3>Manual</h3>
				<img src="assets/images/configuration-items/fridge-diagrams/plus-four-manual.webp" width="100%" height="auto"  alt="Plus Four Manual Emissions" />
				<h3>Automatic</h3>
				<img src="assets/images/configuration-items/fridge-diagrams/plus-four-auto.webp" width="100%" height="auto" alt="Plus Four Auto Emissions" />
			</div>
		</div>
	);
}